import { render, staticRenderFns } from "./ArticleSkeleton.vue?vue&type=template&id=19ea10c5"
import script from "./ArticleSkeleton.vue?vue&type=script&lang=js"
export * from "./ArticleSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports